import script from "./heatmap-day-trend.vue?vue&type=script&setup=true&lang=js"
export * from "./heatmap-day-trend.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__